import type { Settings } from '../../save/schema';

/** Volume steps of AJUSTES while the design system has no slider (GDD §13.6, issue #63): 0 % to 100 % by 10. */
export const VOLUME_STEPS: readonly number[] = Array.from({ length: 11 }, (_, index) => index * 10);

/** A stored volume (0..1) as the nearest step in percent. */
export function volumeToPercent(volume: number): number {
  return Math.min(100, Math.max(0, Math.round(volume * 10) * 10));
}

/** A step in percent as the stored volume (0..1). */
export function percentToVolume(percent: number): number {
  return Math.min(100, Math.max(0, percent)) / 100;
}

export type ToggleKey = Exclude<keyof Settings, 'musicVolume' | 'sfxVolume'>;
export type VolumeKey = 'musicVolume' | 'sfxVolume';

/** The five options of GDD §13.6, in order, with their catalog keys. */
export const SETTING_CONTROLS = [
  { key: 'musicVolume', kind: 'volume', label: 'ui.ajustes.musicVolume' },
  { key: 'sfxVolume', kind: 'volume', label: 'ui.ajustes.sfxVolume' },
  { key: 'reducedMotion', kind: 'toggle', label: 'ui.ajustes.reducedMotion' },
  { key: 'assistMode', kind: 'toggle', label: 'ui.ajustes.assistMode' },
  { key: 'showFps', kind: 'toggle', label: 'ui.ajustes.showFps' },
] as const;
